






































































import { Component, Vue } from 'nuxt-property-decorator'
import { RxFormBuilder, IFormGroup } from '@rxweb/reactive-forms'
import { authStore, userStore } from '~/store'
import Spinner from '~/components/shared/Spinner.vue'
import Button from '~/components/shared/Button.vue'
import Input from '~/components/shared/inputs/Input.vue'
import routes from '~/constants/routerPath.js'
import { LoginForm } from '~/models/forms'
import { InputType } from '~/enums/inputType'
import { ProjectError } from '~/utils/exceptions'
import {
  ACCESS_DISABLED_ROUTE,
  CHANGE_PASSWORD_ROUTE,
} from '~/utils/navigationAuth'
import { User } from '~/models'

@Component({
  layout: 'public',
  middleware: 'store',
  components: {
    Spinner,
    Button,
    Input,
  },
})
export default class Login extends Vue {
  inputType: typeof InputType = InputType
  errorText: string | null = null
  loading = false
  userNameDefaultText = 'Your email address. e.g. name@company.com'
  passwordDefaultText = 'Password must be 8 letters, two numbers and one symbol'
  routerpath: any = routes

  loginFormGroup!: IFormGroup<LoginForm>
  formBuilder: RxFormBuilder = new RxFormBuilder()

  constructor() {
    super()
    this.loginFormGroup = this.formBuilder.formGroup(
      LoginForm
    ) as IFormGroup<LoginForm>
  }

  get currentYear() {
    return new Date().getFullYear()
  }

  getInputText(input: string): string {
    if (this.errorText) {
      return this.errorText
    }
    if (input === 'username') {
      return this.userNameDefaultText
    } else {
      return this.passwordDefaultText
    }
  }

  async submitWithEnter(event: any) {
    if (event.code === 'Enter') {
      await this.submitForm()
    }
  }

  async submitForm() {
    if (this.loginFormGroup.valid) {
      try {
        this.loading = true
        await authStore.login(this.loginFormGroup.value)
        const redirect: string = userStore.redirectUrlByProject

        const user: User = userStore.user
        if (user && user.must_change_password) {
          this.$router.push(CHANGE_PASSWORD_ROUTE)
        } else if (authStore.redirectUrl) {
          this.$router.push(authStore.redirectUrl)
        } else {
          this.$router.push(redirect)
        }
      } catch (error) {
        if (error instanceof ProjectError) {
          this.$toast.error(error.message)
          this.$router.push(ACCESS_DISABLED_ROUTE)
        } else {
          this.loading = false
          this.errorText = 'Please enter valid credentials'
        }
      }
    } else {
      this.loginFormGroup.controls.email.markAsDirty()
      this.loginFormGroup.controls.password.markAsDirty()
    }
  }
}
